export enum WeightTypeEnum {
  TOTAL = "TOTAL",
  PER_ITEM = "PER_ITEM",
}
